import { GuidePostService } from "@oldDashboard/legacyServices/guide-posts/guidePostService";
import { AccountService } from "@oldDashboard/legacyServices/account/accountService";
import { useState } from "react";
import { selectLaunchAction, selectTimePeriodAction, setLaunchesAction, setTimePeriodsAction } from "@oldDashboard/legacyActions/dashboardClient";
import { selectAffiliateAction, setAfilliatesAction } from "@oldDashboard/legacyActions/account";


interface useFiltersProps { affiliateSelected: String, launchSelected: String }
const useFilters = (props: useFiltersProps) => {
    const { affiliateSelected, launchSelected } = props;
    const [isLoading, setIsLoading] = useState(false);
  
    const fetchLaunches = async () => {
        setIsLoading(true);
        try {
            const service = new GuidePostService();
            const filters = await service.getFiltersData(affiliateSelected, launchSelected);
            if (filters) {
                setLaunchesAction(filters!.launches);
                selectLaunchAction(filters!.launchId);
                setTimePeriodsAction(filters!.periods);
                selectTimePeriodAction(filters!.timePeriodKey);
            }
        } catch (error: any) {
            console.log("ERROR ", error)
        } finally {
            setIsLoading(false);
        }
    }

    const fetchAffiliates = async () => {
        setIsLoading(true);
        try {
            const service = new AccountService();
            const affiliates = await service.getAffiliates();
            if(affiliates.success) {
                setAfilliatesAction(affiliates.data.affiliates);
                if(affiliateSelected == "")
                    selectAffiliateAction(affiliates.data.affiliate_id);
            }
        } catch (error: any) {
            console.log("ERROR ", error)
        } finally {
            setIsLoading(false);
        }
    };

    return { fetchAffiliates, fetchLaunches, isLoading}
}

export default useFilters